import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';
import logo from '../../../assets/images/logo.png';
import headerStyles from './Header.module.scss';
import { navLinks } from '../constants';

const Header = ({ onHamburgerClick, isNavOpen, closeNav }) => {
  const location = useLocation();

  const handleNavClick = (e, to, section) => {
    if (to === '/' && location.pathname === '/') {
      e.preventDefault();
      if (window.scrollY > 0) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      return;
    }
    if (location.pathname === to && section) {
      e.preventDefault();
      const el = document.getElementById(section);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className={headerStyles.header} role="banner">
      <div className={headerStyles.headerContent}>
        <div className={headerStyles.logoContainer}>
          <a href="#" aria-label="mobiyo home"><img className={headerStyles.logo} src={logo} alt="mobiyo" /></a>
          <a className={headerStyles.title} href="#">mobiyo</a>
        </div>
        <nav className={`${headerStyles.nav} ${isNavOpen ? headerStyles.navOpen : ''}`} onClick={closeNav} aria-label="Main navigation">
          <ul className={headerStyles.navList}>
            {navLinks.map(link => (
              <li className={headerStyles.navItem} key={link.to}>
                <Link
                  className={headerStyles.navLink}
                  to={link.to}
                  onClick={e => handleNavClick(e, link.to, link.section)}
                  aria-current={location.pathname === link.to ? 'page' : undefined}
                >
                  {link.label}
                </Link>
              </li>
            ))}
            <li className={headerStyles.navItem}>
              <Link to="/login" className={headerStyles.navLink}>Login</Link>
            </li>
          </ul>
        </nav>
        <button 
          className={`${headerStyles.hamburger} ${isNavOpen ? headerStyles.hamburgerOpen : ''}`} 
          onClick={onHamburgerClick}
          aria-label="Toggle navigation menu"
          aria-expanded={isNavOpen}
        >
          <span className={headerStyles.bar}></span>
          <span className={headerStyles.bar}></span>
          <span className={headerStyles.bar}></span>
        </button>
      </div>
    </header>
  );
};

export default Header; 
